import { withNaming } from '@bem-react/classname'

const cn = withNaming({ e: '__', m: '_', v: '_' })

export default cn
